import { yupResolver } from '@hookform/resolvers/yup';
import Form from '../../../Form/Form';
import { chooseLoginData } from './ChooseLoginModalForm.data';
import { ChooseLoginModalFormSchema } from './ChooseLoginModalForm.types';
import { useForm, useWatch } from 'react-hook-form';
import { getChooseLoginSchema } from './ChooseLoginModalForm.schema';
import { UserRoles } from '../../../../../types/models/user/user.types';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();

  const formProps = useForm<ChooseLoginModalFormSchema>({
    resolver: yupResolver(getChooseLoginSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { control, handleSubmit } = formProps;

  const userType = useWatch({
    control,
    name: 'userType',
  });

  const onSubmit = handleSubmit(({ userType }) => {
    if (userType === UserRoles.Entreprise) {
      navigate('/login/entreprise');
    } else {
      navigate('/login/acheteurs');
    }
  });

  return (
    <Form<ChooseLoginModalFormSchema>
      data={chooseLoginData}
      {...{ formProps, onSubmit }}
      isCompany={userType === UserRoles.Entreprise}
    />
  );
};
